import ScrollingModal from './scrollingModal';


export default ScrollingModal;